import axiosApi from '../../../axios/axios-api'

if (!String.format) {
  String.format = function (format) {
    var args = Array.prototype.slice.call(arguments, 1)
    return format.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] !== 'undefined'
        ? args[number]
        : match
    })
  }
}
const state = {
  savedMessage: '',
  savedData: '',
  accionesNavegacion: [],
  homeLastState: {}
}
const mutations = {
  setMessages: (state, payload) => {
    localStorage.setItem('messages', JSON.stringify(payload))
  },
  setMessageData: (state, payload) => {
    state.savedMessage = payload.message
    state.savedData = payload.data
  },
  setAccionesNavegacion: (state, payload) => {
    state.accionesNavegacion = payload.data
  },
  setHomeLastState: (state, payload) => {
    state.homeLastState = payload
  }

}
const actions = {
  fetchMensajes: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axiosApi.get('Recepcion/MensajesAR').then(response => {
        var responseData = response.data
        var messages = responseData.data
        commit('setMessages', messages)
        resolve()
      })
    })
  },
  fetchAccionesAR: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      axiosApi.get(`Autorecepcion/acciones?totemId=${payload.totemId}&onlyEnabled=true`).then(response => {
        var acciones = response.data
        commit('setAccionesNavegacion', acciones)
        resolve()
      })
    })
  }
}
const getters = {
  getMessage: (state) => {
    return (key, variables) => {
      const messages = JSON.parse(localStorage.getItem('messages'))
      const message = messages.find(function (message) {
        return message.key === key
      })
      if (!message) {
        return 'TEXTO NO CONFIGURADO'
      }
      if (variables && variables.length > 0) {
        return String.format(message.value, variables)
      } else {
        return message.value
      }
    }
  },
  getAccionesNavegacion: (state) => {
    return state.accionesNavegacion
  },
  getHomeLastState: (state) => {
    return state.homeLastState
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
